import React from 'react';
import { motion } from 'framer-motion';

export default function SettingRow({
  label,
  description,
  control,
  action,
  actionLabel,
  onAction,
  actionLoading = false,
  className = '',
}) {
  return (
    <div className={`flex items-center justify-between gap-4 py-4 ${className}`}>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-gray-900 dark:text-white">{label}</p>
        {description && (
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{description}</p>
        )}
      </div>
      <div className="flex items-center gap-3 flex-shrink-0">
        {control && <div className="min-w-[200px]">{control}</div>}
        {action && (
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={onAction}
            disabled={actionLoading}
            className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg transition-colors disabled:opacity-50 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700"
          >
            {action}
          </motion.button>
        )}
      </div>
    </div>
  );
}
